import InnerHTML from 'dangerously-set-html-content';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../helpers/app_state';
import { serializeHyperlink } from '../../lib/serializers';
import { linkResolver } from '../../prismic';
import { getVideoByUid } from '../../redux/videos';
import { RoutePaths } from '../../routes';
import { ContentWrapper } from '../content_wrapper/content_wrapper';
import { List } from '../list/list';
import { OmniaBreadcrumb } from '../omnia_breadcrumb/omnia_breadcrumb';
import ProductFamilyRows from '../product_family_rows/product_family_rows';
import { SEO } from '../seo/seo';
import { WistiaEmbed } from '../wistia_embed/wistia_embed';
import cssStyles from './video_detail.less';

export const VideoDetail = (props: { uid: string }) => {
  const video = useSelector((state: ApplicationState) => getVideoByUid(state, props.uid));

  if (!video) {
    return null;
  }

  const prismicVideo = video.data;
  return (
    <>
      <SEO
        title={prismicVideo.meta_title || RichText.asText(prismicVideo.title)}
        description={prismicVideo.meta_description}
      />
      <ContentWrapper tag="section" className={cssStyles.wrapper}>
        <article className={cssStyles.article}>
          <OmniaBreadcrumb
            items={[
              {
                name: 'Fishing Articles',
                url: RoutePaths.FISHING_ARTICLES,
              },
              {
                name: RichText.asText(prismicVideo.title),
                url: null,
              },
            ]}
            style={{ marginBottom: '24px', textTransform: 'capitalize' }}
          />

          <div className={cssStyles.body}>
            <div className={cssStyles.articleText}>
              <h1 className={cssStyles.title}>{RichText.asText(prismicVideo.title)}</h1>

              {prismicVideo.body.map((slice, i) => {
                switch (slice.slice_type) {
                  case 'waterbody': {
                    return null;
                  }
                  case 'list': {
                    return <List key={`list:${slice.primary.list.id}`} list={slice.primary.list} />;
                  }
                  case 'product_family': {
                    return (
                      <ProductFamilyRows
                        key={`list:${slice.primary.product_family.handle}`}
                        productFamily={slice.primary.product_family}
                        products={slice.primary.product_family.products}
                        brand={null}
                      />
                    );
                  }
                  case 'text': {
                    return (
                      <RichText
                        render={slice.primary.text}
                        linkResolver={linkResolver as any}
                        serializeHyperlink={serializeHyperlink as any}
                        key={`${slice.primary.text[0].text}:${slice.primary.text.length}`}
                      />
                    );
                  }
                  case 'wistia_video': {
                    const { embed_url } = slice.primary.video_wistia;
                    return <WistiaEmbed embedUrl={embed_url} key={embed_url} />;
                  }
                  case 'raw_html': {
                    return <InnerHTML html={slice.primary.html} key={`${slice.slice_type}${i}`} />;
                  }
                }
              })}
            </div>
          </div>
        </article>
      </ContentWrapper>
    </>
  );
};
